"use strict";

module.exports = /*@ngInject*/function () {
  var _this = this;
  return {
    errors: [],
    // Is the current user authenticated?
    addError: function addError(error) {
      _this.errors.push(error);
    },
    clearErrors: function clearErrors() {
      _this.errors.length = 0;
    }
  };
};